import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  output,
  Output,
  ViewChild,
} from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { Comparison } from 'app/providers/bridge-api/dashboard.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { BreakdownTableComponent } from '../breakdown-table/breakdown-table.component';
import { MetricSettingsModalResult } from '../metric-settings-modal/metric-settings-modal.component';
import { MetricSettingsPillComponent } from '../metric-settings-pill/metric-settings-pill.component';
import { WidgetPredictiveOptions } from '../widget-predictive/widget-predictive.component';
import { IExportCanvas } from '../../models/export-canvas';
import { Breakdown } from '../../models/predictive.models';

@EnableClassTelemetry()
@Component({
  selector: 'app-predictive-breakdown-widgetette',
  imports: [AppSharedModule, BreakdownTableComponent, MetricSettingsPillComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './predictive-breakdown-widgetette.component.html',
  styleUrls: ['./predictive-breakdown-widgetette.component.scss'],
})
export class PredictiveBreakdownWidgetetteComponent implements IExportCanvas {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() breakdowns!: Breakdown[];
  @Input() focusedBreakdown!: Breakdown;
  @Input() predictiveOptions!: WidgetPredictiveOptions;
  @Input() isReadOnly!: boolean;
  @Input() isDashboardLocked!: boolean;
  @Input() comparison?: Comparison;

  @Output() selectBreakdown = new EventEmitter<Breakdown>();
  @Output() resetBreakdownSimulation = new EventEmitter<Breakdown>();
  @Output() metricSettingsChange = new EventEmitter<MetricSettingsModalResult>();

  hideBreakdown = output<Breakdown>();

  @ViewChild(BreakdownTableComponent) breakdownTable: BreakdownTableComponent;

  onSelectBreakdown(breakdown: Breakdown): void {
    this.selectBreakdown.emit(breakdown);
  }

  onHideBreakdown(breakdown: Breakdown): void {
    this.hideBreakdown.emit(breakdown);
  }

  onResetBreakdownSimulation(breakdown: Breakdown): void {
    this.resetBreakdownSimulation.emit(breakdown);
  }

  onMetricSettingsChange(result: MetricSettingsModalResult): void {
    this.metricSettingsChange.emit(result);
  }

  exportCanvas(): Promise<HTMLCanvasElement> {
    return this.breakdownTable.exportCanvas();
  }
}
